import { createPrismic } from '@prismicio/vue';

export default createPrismic({
  // Yes this says enpoint without a d, thanks Elgentos for the typo
  endpoint: window.store_config['prismicio/general/enpoint'] ?? '',
});
